import {Component, OnInit, ViewChild, ViewEncapsulation, ElementRef} from '@angular/core';
import { HostListener } from "@angular/core";
import {state, style, transition, animate, trigger, AUTO_STYLE} from '@angular/animations';
import 'rxjs/add/operator/filter';
import { MenuItems } from '../../shared/menu-items/menu-items';
import {Router} from '@angular/router';
import {AuthService} from '../auth/guards/auth.service';
import swal from 'sweetalert2';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translate3d(0, 0, 0)'
      })),
      state('out', style({
        transform: 'translate3d(100%, 0, 0)'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
    trigger('slideOnOff', [
      state('on', style({
        transform: 'translate3d(0, 0, 0)'
      })),
      state('off', style({
        transform: 'translate3d(100%, 0, 0)'
      })),
      transition('on => off', animate('400ms ease-in-out')),
      transition('off => on', animate('400ms ease-in-out'))
    ]),
    trigger('mobileMenuTop', [
      state('no-block, void',
        style({
          overflow: 'hidden',
          height: '0px',
        })
      ),
      state('yes-block',
        style({
          height: AUTO_STYLE,
        })
      ),
      transition('no-block <=> yes-block', [
        animate('400ms ease-in-out')
      ])
    ])
  ]
})

export class AdminComponent implements OnInit {
 

  public showfirstheader = true;
  public defaultheader = false;
  public investorheader = false;
  public loginUrl: any;
  res: any;
  userName: any;
  profilePic: any = "5f07ef31b35a3405b3acd448";
  imageURL: any;
  
  constructor(public menuItems: MenuItems, public router: Router, public authService: AuthService) {}
  
  ngOnInit() {
  // alert('hiwllo')
    setInterval(() => {
      this.authService.getUserData()
      .subscribe( res => {
      //  alert('hiwllo2')
      //  console.log(res)
        this.res = res;
        this.userName = this.res.data.firstName + ' ' +this.res.data.lastName;
        this.profilePic = this.res.data.profilePic;
        if(this.profilePic != undefined) {
         // this.imageURL = "https://api.cycloan.io/api/v1/files/profilePic/" + this.profilePic
         this.imageURL = environment.baseURL+"files/profilePic/" + this.profilePic
        } else {
         
          this.imageURL = "assets/images/user.png"
        }
      //  console.log(this.profilePic)
      }, error => {
      //  this.authService.logout();
      })
    }, 1000)
  
    setInterval(() => {
      this.checkforheader();
  }, 1000);
  setInterval(() => {
    this.checksessiontimeout();
  }, 2000);   
  }

  public checksessiontimeout() {
    this.loginUrl = 'auth/login';
    const now: any = new Date().getTime();
   // console.log(now);
    const setupTime: any = sessionStorage.getItem('setupTime');
  //  console.log(now - setupTime);
    if (setupTime == null) {
        // localStorage.setItem('setupTime', now);
    } else {
        if (now - setupTime > 100 * 60 * 1000) {
            //  console.log(now - setupTime)
       //     console.log("control coming")
            sessionStorage.clear();
            swal.fire('Session timeout', 'Please login again', 'warning');
            this.router.navigate([this.loginUrl]);
        }
    }
}

  public checkforheader(){
    const route1 = this.router.url;
    var splits = route1.split("/");
    if(splits[1] == 'sponsorregistration' || splits[1] == 'sponsorcontact' || splits[1] == 'smeuploadfiles' || splits[1] == 'smeregistation' || splits[1] == 'smecontact' || splits[1] == 'sponsoruploadfiles'){
        this.showfirstheader = true;
        this.defaultheader = false;
        this.investorheader = false;
    } else if(splits[1] == 'smedashboard'  || splits[1] == 'mysmeprojects' || splits[1] == 'viewsmeprojects'  || splits[1] == 'sme'){
      this.showfirstheader = false;
      this.defaultheader = true;
      this.investorheader = false;
    } else {
      this.showfirstheader = false;
      this.defaultheader = false;
      this.investorheader = true;      
    }
  }

  logout(): void {
    //console.log("log out calling")
    this.authService.logout();
    window.location.href = '/auth/login';
  }
 

}
